// 导入自定义钱包连接 hook
import useConnectWallet from "@/store/wallet/useConnectWallet";
// 导入 React 的 useCallback 和 useState
import { useCallback, useState } from "react";

/**
 * 获取推荐人状态的自定义 hook。
 *
 * 提供 getHasReferrer 方法用于判断指定地址是否有推荐人，
 * 并返回加载状态。
 */
const useGetReferrerState = () => {
    // 从 useConnectWallet 获取 FFR 合约实例
    const { contractEvm: { RegularStaking } } = useConnectWallet()
    // 加载状态，表示是否正在查询
    const [getHasReferrerStateLod, setLoading] = useState(false);
    /**
     * 查询指定地址是否有推荐人
     * @param address 用户钱包地址
     * @returns 是否有推荐人（布尔值）
     */
    const getHasReferrerState = useCallback(async (address: string) => {
        try {
            if (RegularStaking) {
                setLoading(true);
                // 调用合约的 hasReferrer 方法检查是否已注册
                const is = await RegularStaking.hasReferrer(address)
                return is
            }
        } catch (e) {
            // 捕获异常并输出错误信息
            console.log('useHasReferrer', e);
        } finally {
            // 查询结束后重置加载状态
            setLoading(false);
        }
    }, [RegularStaking])
    // 返回查询方法和加载状态
    return {
        getHasReferrerState,
        getHasReferrerStateLod
    }
}

// 导出自定义 hook
export default useGetReferrerState